import { GroupType } from '../../constants'
import serverData from '../../utils/server-data'
import Events from './eventTags'

export function initCommonProps() {
  const initProps = {
    comp: 'groupsnodeweb',
    session_id: serverData?.sessionId,
    app_version: serverData?.appVersion,
    encr_cust_id: serverData?.user?.encryptedAccountNumber,
    visitor_id: serverData?.visitorId,
    user_country: serverData?.user?.country,
    channel: serverData?.deviceInfo?.isMobile ? 'mweb' : 'web',
    browser_type: serverData?.deviceInfo?.browserName || 'unknown',
    browser_version: serverData?.deviceInfo?.browserVersion || 'unknown',
    operating_system: serverData?.deviceInfo?.osName || 'unknown',
    operating_system_version: serverData?.deviceInfo?.osVersion || 'unknown',
    space_key: serverData?.spaceKeys?.paypalP2p,
  }
  Events.initCommonProps(initProps)
}

let analytics = undefined as { record: (data: any) => void }

export const getAnalytics = () => {
  return analytics
}

/*************
 * Public API
 *************/

/**
 *  Tracks events on a page
 *  @param {Object} [data] data to send to FPTI
 */
export const tracking = (data: any = {}) => {
  if (!analytics) {
    analytics = new (window as any).PAYPAL.analytics.Analytics()
  }
  analytics.record({ data })
}

export const getPoolsListPageVariant = (
  totalCount: number,
  chosenGroupType: GroupType,
) => {
  let pageVariant = ''
  const isEmptyList = totalCount <= 0

  if (isEmptyList && chosenGroupType === GroupType.CONTRIBUTED) {
    pageVariant = 'contributed_empty'
  } else if (isEmptyList && chosenGroupType === GroupType.CREATED) {
    pageVariant = 'created_empty'
  } else if (!isEmptyList && chosenGroupType === GroupType.CONTRIBUTED) {
    pageVariant = 'contributed_full'
  } else if (!isEmptyList && chosenGroupType === GroupType.CREATED) {
    pageVariant = 'created_full'
  }

  return pageVariant
}

export const getGroupDetailPageVariant = (
  isAdmin: boolean,
  isPayPalUser: boolean,
) => {
  if (isAdmin) {
    return 'creator'
  } else if (isPayPalUser) {
    return 'paypal_contributor'
  }
  return 'guest_contributor'
}
